"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.UpdateIOSTokenVariantCommand = void 0;
const AbstractUpdateVariantCommand_1 = require("./AbstractUpdateVariantCommand");
class UpdateIOSTokenVariantCommand extends AbstractUpdateVariantCommand_1.AbstractUpdateVariantCommand {
    constructor(api, appId, variantId) {
        super(api, appId, variantId, 'ios_token');
        this.withTeamID = (teamId) => {
            this.def.teamId = teamId;
            return this;
        };
        this.withKeyID = (keyId) => {
            this.def.keyId = keyId;
            return this;
        };
        this.withBundleID = (bundleId) => {
            this.def.bundleId = bundleId;
            return this;
        };
        this.withPrivateKey = (privateKey) => {
            this.def.privateKey = privateKey;
            return this;
        };
        this.isProduction = () => {
            this.def.production = true;
            return this;
        };
        this.isDevelopment = () => {
            this.def.production = false;
            return this;
        };
    }
}
exports.UpdateIOSTokenVariantCommand = UpdateIOSTokenVariantCommand;
//# sourceMappingURL=UpdateIOSTokenVariantCommand.js.map